import React, { useState } from "react";
import Quiz from "./Single/Quiz";
import ToggleAnswersButton from "../../Elements/ToggleAnswersButton";

interface QuizzesProps {
  phase: {
    themes: any[];
  };
  type?: boolean;
  erudit?: boolean;
}

const Quizzes: React.FC<QuizzesProps> = ({ phase }) => {
  const [opens, setOpens] = useState<string[]>([]);

  const allOpen = (): boolean => {
    if (!phase) return false;
    return phase.themes.every(q =>
      [0, 1, 2, 3, 4].every(i => opens.includes(`${q.id}-${i}`))
    );
  };

  const toggleAll = () => {
    if (allOpen()) {
      setOpens([]);
    } else {
      const all: string[] = [];
      phase.themes.forEach(q => {
        [0, 1, 2, 3, 4].forEach(i => all.push(`${q.id}-${i}`));
      });
      setOpens(all);
    }
  };

  const toggleOpen = (themeId: number, questionIndex: number) => {
    const key = `${themeId}-${questionIndex}`;
    setOpens(prev =>
      prev.includes(key) ? prev.filter(o => o !== key) : [...prev, key]
    );
  };

  if (!phase) return null;

  return (
    <>
      <ToggleAnswersButton isOpen={allOpen()} onToggle={toggleAll} className="mb-4" />
      <div>
        {phase.themes.map(th => (
          <Quiz
            key={th.id}
            theme={th}
            opens={opens}
            toggleOpen={toggleOpen}
          />
        ))}
      </div>
    </>
  );
};

export default Quizzes;
